import React, { useState, useContext } from "react";

import { Link as RouterLink } from "react-router-dom";

import Button from "@material-ui/core/Button";

import CssBaseline from "@material-ui/core/CssBaseline";

import TextField from "@material-ui/core/TextField";

import Link from "@material-ui/core/Link";

import Grid from "@material-ui/core/Grid";

import Typography from "@material-ui/core/Typography";

import { makeStyles, useTheme } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";

import IconButton from "@material-ui/core/IconButton";

import InputAdornment from "@material-ui/core/InputAdornment";

import Visibility from "@material-ui/icons/Visibility";

import VisibilityOff from "@material-ui/icons/VisibilityOff";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";

import Box from "@material-ui/core/Box";

import { GlobalStyles } from "@mui/system";



import { AuthContext } from "../../context/Auth/AuthContext";

import { useLicenseChecker } from "../../license/validateLicense";



// Logo principal, como en su código original
const logo = `${process.env.REACT_APP_BACKEND_URL}/public/logotipos/login.png`;

// Nome do sistema vindo do .env
const systemName = process.env.REACT_APP_NAME_SYSTEM || "Sistema";

// Imagem da ilustração (robô)
const illustrationImage = "https://www.svgrepo.com/show/306905/robot.svg";
// Lembre-se da recomendação de usar uma imagem local:
// const illustrationImage = "/images/robo-icon.svg";



const enableWhatsAppButton = process.env.REACT_APP_ENABLE_WHATSAPP_BUTTON === "true";



const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    overflow: "hidden",
  },
  leftPane: {
    flex: 0.65,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    textAlign: "center",
    position: "relative",
  },
  mainTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  subTitle: {
    marginBottom: theme.spacing(4),
    maxWidth: "400px",
  },
  dotsContainer: {
    position: "absolute",
    bottom: theme.spacing(3),
    display: "flex",
  },
  dot: {
    height: "10px",
    width: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    borderRadius: "50%",
    display: "inline-block",
    margin: "0 5px",
  },
  dotActive: {
    height: "10px",
    width: "10px",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "50%",
    display: "inline-block",
    margin: "0 5px",
  },
  rightPane: {
    flex: 0.35,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : "#F4F7FC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
  loginFormContainer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4, 5),
    borderRadius: theme.spacing(1.5),
    boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "450px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Centraliza el contenido, incluyendo el logo
  },
  // Clase del logo, como en su código original
  logo: {
    width: "300px", // ATENCIÓN: Puede ser demasiado grande para esta columna. Ajustar si es necesario.
    marginBottom: theme.spacing(3), // Aumenté un poco el margen inferior
    display: "block", // Mantenido de su original
  },
  greeting: {
    alignSelf: 'flex-start',
    width: '100%',
    // marginTop: theme.spacing(1), // Removido pois a logo agora tem marginBottom
    marginBottom: theme.spacing(0.5),
    fontWeight: '500',
    textAlign: 'center', // Centralizando o texto de saudação como na imagem de referência
  },
  instructionText: {
    alignSelf: 'flex-start',
    width: '100%',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
    textAlign: 'center', // Centralizando o texto de instrução
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#1E252F",
    color: "#fff !important",
    borderRadius: "8px",
    padding: theme.spacing(1.5),
    textTransform: "none",
    fontWeight: 'bold',
    "&:hover": {
      backgroundColor: "#344050",
    },
  },
  passwordIcon: {
    cursor: "pointer",
    color: theme.palette.text.secondary,
  },
  inputLabel: {
    color: theme.palette.text.secondary,
  },
  linkForgotPassword: {
    textAlign: 'right',
    width: '100%',
    display: 'block',
    marginTop: theme.spacing(1),
  },
  linkSignup: {
    textAlign: 'center',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  copyright: {
    marginTop: theme.spacing(3),
    color: theme.palette.text.secondary,
    textAlign: 'center',
    width: '100%',
  },
  whatsappButton: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: "#25d366",
    "&:hover": {
      backgroundColor: "#128c7e",
    },
  },
  whatsappIcon: {
    fontSize: 40,
    color: "#fff",
  },
}));



const Login = () => {
  const { plano } = useLicenseChecker();
  const classes = useStyles();
  const theme = useTheme();

  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const { handleLogin } = useContext(AuthContext);

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={classes.root}>
      <GlobalStyles
        styles={{
          "input:-webkit-autofill": {
            "-webkit-box-shadow": theme.palette.type === 'dark' ? `0 0 0 100px ${theme.palette.background.paper} inset !important` : `0 0 0 100px #F4F7FC inset !important`,
            "-webkit-text-fill-color": `${theme.palette.getContrastText(theme.palette.background.paper)} !important`,
            'caret-color': `${theme.palette.getContrastText(theme.palette.background.paper)} !important`,
            'border-radius': '8px',
          },
          ".MuiOutlinedInput-root": {
            backgroundColor: theme.palette.type === 'dark' ? '#333' : '#F4F7FC',
            borderRadius: '8px',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
            },
          },
          ".MuiOutlinedInput-notchedOutline": {
             borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
          },
          ".MuiInputLabel-outlined": {
             color: theme.palette.text.secondary,
          },
        }}
      />

      {/* Coluna da Esquerda */}
      <div className={classes.leftPane}>
        <Typography variant="h3" component="h1" className={classes.mainTitle}>
          CRM WhatsApp
        </Typography>
        <Typography variant="h6" component="p" className={classes.subTitle}>
          Plataforma de gestión de chat
        </Typography>
        <div className={classes.dotsContainer}>
          <span className={classes.dot}></span>
          <span className={classes.dotActive}></span>
          <span className={classes.dot}></span>
        </div>
      </div>

      {/* Coluna da Direita */}
      <div className={classes.rightPane}>
        <Container component="div" className={classes.loginFormContainer}>
          <CssBaseline />
          
          {/* Logo llamado como en su código original */}
          <img src={logo} alt="Logo de la Empresa" className={classes.logo} />
          
          {/* Textos de saudação e instrução (centralizados para seguir a imagem de referência) */}
          <Typography component="h2" variant="h6" className={classes.greeting}>
            ¡Hola, empecemos! 👋
          </Typography>
          <Typography variant="body2" className={classes.instructionText}>
            Bienvenido al sistema, inicia sesión para continuar.
          </Typography>

          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              // label="Endereço de e-mail" // Label como na imagem de referência
              placeholder="Dirección de correo electrónico *" // Usando placeholder como na imagem
              name="email"
              autoComplete="email"
              autoFocus
              value={user.email}
              onChange={handleChangeInput}
              InputLabelProps={{ // Manter se for usar label em vez de placeholder
                // className: classes.inputLabel, 
                shrink: false, // Para não mostrar o label se o placeholder estiver visível
              }}
              // Remover label se for usar placeholder e o TextField não o ocultar automaticamente
              label={user.email ? "" : "Dirección de correo electrónico"} 
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              // label="Senha" // Label como na imagem de referência
              placeholder="Contraseña *" // Usando placeholder como na imagem
              type={showPassword ? "text" : "password"}
              id="password"
              autoComplete="current-password"
              value={user.password}
              onChange={handleChangeInput}
              InputLabelProps={{ // Manter se for usar label em vez de placeholder
                // className: classes.inputLabel,
                shrink: false, // Para não mostrar o label se o placeholder estiver visível
              }}
              // Remover label se for usar placeholder e o TextField não o ocultar automaticamente
              label={user.password ? "" : "Contraseña"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      className={classes.passwordIcon}
                      onClick={toggleShowPassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
             <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                    {/* Checkbox "Lembrar senha" (opcional) */}
                </Grid>
                <Grid item>
                    <Link component={RouterLink} to="/forgetpsw" variant="body2" style={{color: theme.palette.text.secondary}}>
                        ¿Olvidaste tu contraseña?
                    </Link>
                </Grid>
            </Grid>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              className={classes.submit}
              style={{ backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }}
            >
              Iniciar Sesión
            </Button>
            <Grid container justifyContent="center">
              {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                <Grid item className={classes.linkSignup}>
                  <Link component={RouterLink} to="/signup" variant="body2" style={{color: theme.palette.text.secondary}}>
                    ¿Aún no tienes una cuenta?{" "}
                    <span style={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>Crear nueva cuenta</span>
                  </Link>
                </Grid>
              )}
            </Grid>
            <Box mt={2} className={classes.copyright}>
              <Typography variant="body2" color="textSecondary" align="center">
                © {new Date().getFullYear()} {systemName}
              </Typography>
            </Box>
          </form>
        </Container>
      </div>

      {enableWhatsAppButton && (
        <IconButton
          href={`https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`}
          className={classes.whatsappButton}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contact support on WhatsApp"
        >
          <WhatsAppIcon className={classes.whatsappIcon} />
        </IconButton>
      )}
    </div>
  );
};



export default Login;